import React from 'react'
import { i18nTranslate, parseMenuCategory, convertToBoolean } from 'src/utils'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import {
  VscClose as CloseIcon,
  VscChevronRight,
  VscChevronLeft,
} from 'react-icons/vsc'
import { Link } from 'react-router-dom'
import { Col, Image, ListGroup, Row } from 'react-bootstrap'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import { getCategoryLinks } from './deps'
import { mobileMenuState } from 'src/views/components'
import SubMenuAccordian from './SubMenuAccordian'
import { staticDropDownLinks } from '../staticDropDownLinks'
import { PageLink } from 'src/views/components/PageLink'
import { catalogDeps } from 'src/deps'
import rightArrow from 'src/images/rightarrow.png'
import {
  checkForLegacyURL,
  enableNewFeature,
  getAbsoluteURLForLegacy,
  isExternalUrl,
  normalizeExternalUrl,
} from 'src/utils/commonUtils'
import { APPConfig } from 'config/appConfig'

class CategoryItem extends React.Component {
  handleClick = () => {
    const { index, currentCategoryPath } = this.props
    currentCategoryPath?.push('subCategories', index?.toString())
  }

  render() {
    const { category } = this.props
    const categoryName = parseMenuCategory(category?.properties?.name || '')
    const ForwardIcon = VscChevronRight
    return (
      <ListGroup.Item
        key={categoryName}
        className="nu-menu-item"
        onClick={this.handleClick}>
        <a href="javascript:void(0)" role="button">
          {categoryName}
        </a>
        <ForwardIcon size="24px" className="ml-auto arrow-icon" />
      </ListGroup.Item>
    )
  }
}

class BrowseLink extends React.Component {
  nameSpace = 'ssr-resource'
  hardcodedCategoryLinks = {
    sustainability:
      'https://www.nuskin.com/content/globalffg/sustainability/home.html',
    socialimpact: 'https://www.nuskin.com/content/globalffg/home.html',
  }
  handleClick = () => {
    this.props?.handleLinkClick()
  }

  render() {
    const { category } = this.props
    const {
      name: categoryName = '',
      description = '',
      meta_description = '',
      imageURL = '',
    } = category?.properties || {}

    const categoryDescription =
      description ||
      meta_description ||
      i18nTranslate(
        'menu.description',
        'Description not available for this product/category.',
        { nameSpace: this.nameSpace }
      )

    const isThirdPartyPage =
      category?.isFromOurImpact ||
      this.hardcodedCategoryLinks?.[category?.identifier]
    const href = category?.properties?.href || this.hardcodedCategoryLinks?.[category?.identifier]
    const subCategoryJSX = isThirdPartyPage ? (
      <a
        href={
          href
        }
        target={(href?.includes('/content') || href?.includes('/site') ? "_self" : "_blank")}
        rel="noopener noreferrer"
        key={parseMenuCategory(categoryName)}>
        {parseMenuCategory(categoryName)}
      </a>
    ) : (
      <Link
        to={getCategoryLinks(category)}
        onClick={this.handleClick}
        key={parseMenuCategory(categoryName)}>
        {parseMenuCategory(categoryName)}
      </Link>
    )

    return imageURL && categoryDescription && category?.parentId !== 'top' ? (
      <Row className="m-2">
        <Col xs={12} className="text-center">
          <Image alt={name} src={imageURL} height="200px" width="auto"></Image>
        </Col>
        <Col xs={12} className="text-left mt-3">
          <b>{subCategoryJSX}</b>
        </Col>
        <Col xs={12} className="text-left mb-3 nu-menu-subcategory-desc">
          <span className={'category-description-html'}>
            {parseMenuCategory(categoryDescription)}
          </span>
        </Col>
      </Row>
    ) : (
      <ListGroup.Item className="nu-browse-link nu-menu-item">
        {subCategoryJSX}
      </ListGroup.Item>
    )
  }
}

class SubCategoryHeader extends React.Component {
  handleClick = () => {
    const { currentCategoryPath } = this.props
    currentCategoryPath?.splice(-2, 2)
  }
  render() {
    const { category, currentCategoryPath, handleLinkClick } = this.props
    const { imageURL, name } = category?.properties || {}

    const BackIcon = VscChevronLeft
    return (
      <div
        className="subcategory-header list-group-item nu-menu-subheading text-uppercase d-flex justify-content-between"
        onClick={this.handleClick}
        role="button">
        <div>
          <BackIcon size="24px" className="mr-2" />
          {parseMenuCategory(name || '')}
        </div>
        <CloseIcon size="24px" className="ml-1" />
      </div>
    )
  }
}

@observer
class MobileMenuCategories extends React.Component {
  @observable expandedCategories = new Set()

  componentDidMount() {
    if (enableNewFeature('enableRedesignMainMenu')) {
      import('./mobileMenuCategories.scss').catch(error => {
        console.error('Failed to load mobileMenuCategories.scss:', error)
      })
    }
  }

  handleLinkClick = () => {
    this.props?.currentCategoryPath?.splice(1)
    mobileMenuState?.toggleMenuVisibility()
    if (catalogDeps?.isFilterOpen === true) {
      catalogDeps?.toggleFilter()
    }
  }

  toggleCategory = categoryIndex => {
    if (this.expandedCategories?.has(categoryIndex)) {
      this.expandedCategories?.delete(categoryIndex)
    } else {
      this.expandedCategories?.add(categoryIndex)
    }
  }

  renderSubCategoryItem = (
    item,
    { isLegacyURL, isExternalItem, isLegacyURLOpenInSameTab }
  ) => {
    if (typeof item === 'string') {
      return <span className="mobile-categorymenu-item-text">{item}</span>
    }
    const handleItemClick = e => {
      if (!item?.href) {
        e.preventDefault()
      }
    }
    if (isLegacyURLOpenInSameTab && isLegacyURL) {
      return (
        <a
          href={item?.href || '#'}
          target="_self"
          className="mobile-categorymenu-item-text"
          onClick={handleItemClick}>
          {item?.title}
        </a>
      )
    }
    if (isExternalItem) {
      return (
        <a
          href={normalizeExternalUrl(item?.href)}
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-categorymenu-item-text"
          onClick={handleItemClick}>
          {item?.title}
        </a>
      )
    }
    return (
      <Link
        to={item?.href || '#'}
        target={item?.href?.includes('site') ? '_blank' : '_self'}
        className="mobile-categorymenu-item-text"
        onClick={handleItemClick}>
        {item?.title}
      </Link>
    )
  }

  renderCategoryWithDropdown = (category, index) => {
    const categoryName = category?.properties?.name || category?.label || ''
    const isExpanded = this.expandedCategories?.has(index)
    const enableMobileJumpToSection = enableNewFeature('enableMobileJumpToSection')
    const subcategories = category?.subCategories || []
    const isLegacyURLOpenInSameTab = this.props?.navigationData?.isLegacyURLOpenInSameTab || false
    const legacyURLList = this.props?.navigationData?.legacyURLList || []
    return (
      <div key={`category-${index}`} className="mobile-category-section">
        <ListGroup.Item
          className="nu-menu-item mobile-category-header"
          onClick={() => this.toggleCategory(index)}>
          <a
            href="javascript:void(0)"
            role="button"
            className={isExpanded ? 'expanded' : ''}>
            {categoryName}
          </a>
          <VscChevronRight
            size="24px"
            className={`ml-auto arrow-icon ${isExpanded ? 'expanded' : ''}`}
          />
        </ListGroup.Item>
        {enableMobileJumpToSection && isExpanded && subcategories?.length > 0 && (
            <>{this.renderJumpToSectionForMobile(subcategories)}</>
          )}

        {isExpanded && subcategories?.length > 0 && (
          <div className="mobile-subcategory-dropdown">
            <Row noGutters className="mobile-categorymenu-row">

              {subcategories
                ?.filter(sub => !sub?.label?.toLowerCase()?.includes('jump'))
                ?.map((sub, idx) => (
                  <Col
                    key={idx}
                    md={3}
                    sm={6}
                    xs={12}
                    className="mb-3 mobile-categorymenu-col">
                    <div
                      className="mega-menu-subcategory-title mobile-categorymenu-subcategory-title"
                      tabIndex={0}
                      aria-label={sub?.label}
                    >
                      <span className="mobile-categorymenu-subcategory-title-text">
                        {sub?.label}
                      </span>
                      <Image
                        className="mobile-categorymenu-right-arrow"
                        src={rightArrow}
                        height={20}
                        width={20}
                        alt=""
                        aria-hidden="true"
                      />
                    </div>
                    <ul className="mega-menu-items mobile-categorymenu-items">
                      {sub?.items &&
                        sub?.items?.map((item, i) => {
                        const isLegacyURL = legacyURLList.some((val) => item?.href?.includes(val))
                        const isExternalItem = isExternalUrl(item?.href)
                        return (
                          <li
                            key={i}
                            className="mega-menu-item mobile-categorymenu-item"
                            tabIndex={0}
                            role="menuitem"
                            aria-label={
                              typeof item === 'string' ? item : item?.title
                            }
                            onClick={this.handleLinkClick}>
                            {this.renderSubCategoryItem(item, {
                              isLegacyURL,
                              isExternalItem,
                              isLegacyURLOpenInSameTab,
                            })}
                          </li>
                        )})}
                    </ul>
                  </Col>
                ))}
            </Row>

            {/* Jump To section */}
            {/* {subcategories.find(sub => sub.label.toLowerCase().includes('jump')) && (
              <div className="mobile-jumpto-section">
                <hr width="95%" />
                <Row className="mobile-categorymenu-jumpto-row">
                  <Col xs="auto">
                    <p className="mobile-categorymenu-jumpto-label">Jump To:</p>
                  </Col>
                  {subcategories
                    .find(sub => sub.label.toLowerCase().includes('jump'))
                    ?.items?.map((item, idx) => (
                      <Col xs="auto" key={idx} className="mobile-categorymenu-jumpto-item-col">
                        <span className="mobile-categorymenu-jumpto-item" onClick={this.handleLinkClick}>
                          {item}
                        </span>
                      </Col>
                    ))}
                </Row>
              </div>
            )} */}
          </div>
        )}
      </div>
    )
  }

  renderJumpToSectionForMobile = subcategories => {
      const isLegacyURLOpenInSameTab = this.props?.navigationData?.isLegacyURLOpenInSameTab || false
      const legacyURLList = this.props?.navigationData?.legacyURLList || []
      return (
      subcategories
        ?.filter(sub => sub?.label?.toLowerCase()?.includes('jump'))
        ?.map((sub, idx) => (
          <div className="mobile-categorymenu-jumpTo-wrapper">
          <div
            key={`jump-container-${idx}`}
            className="mobile-categorymenu-jumpTo-container">
            {sub?.items?.map((item, itemIdx) => {
              let href = item?.href || '#'
              const isLegacyURL = legacyURLList.some((val) => href.includes(val))
              href = getAbsoluteURLForLegacy(isLegacyURL, href)
              const isExternaLink = isExternalUrl(href)
              return isExternaLink ? (
                <a
                  key={`jump-item-${itemIdx}`}
                  href={normalizeExternalUrl(href)}
                  className="mobile-categorymenu-jumpTo"
                  onClick={item?.href ? this.handleLinkClick : undefined}
                  target={isLegacyURLOpenInSameTab && isLegacyURL ? "_self" : "_blank"}
                  rel="noopener noreferrer">
                  {typeof item === 'string' ? item : item?.title}
                </a>
              ) : (
                <Link
                  key={`jump-item-${itemIdx}`}
                  to={href}
                  className="mobile-categorymenu-jumpTo"
                  onClick={item?.href ? this.handleLinkClick : undefined}
                  target={item?.href?.includes('site') ? '_blank' : '_self'}>
                  {typeof item === 'string' ? item : item?.title}
                </Link>
              )
            })}
          </div>
          </div>
        ))
      )
  }

  renderStaticDropDownLinks = response => {
    const lists = staticDropDownLinks() || []
    let identifier = ''
    if (response?.identifier?.length > 0) {
      identifier = response?.identifier?.replaceAll?.('_', '') || ''
    }
    let list = lists?.filter(list => list?.parentId === identifier)

    // Apply the same hideCategory filtering logic as desktop
    const isToHideStaticCategory =
      convertToBoolean(APPConfig?.getAppConfig()?.isToHideStaticCategory) ||
      false

    if (isToHideStaticCategory) {
      list = list?.filter(item => item.hideCategory !== true)
    }
    list = checkForLegacyURL(list)
    if (list?.length > 0) {
      return list?.map(item => {
        return (
          <div className="static-links ml-3" key={item?.label}>
            <PageLink
              linkInfo={item?.linkInfo}
              className="text-decoration-none"
              target={enableNewFeature("openLegacyURLInSameTabForOldUI") ? "_self" : "_blank"}
              rel="noopener noreferrer">
              <span data-testid="qa-category">{item?.label}</span>
            </PageLink>
          </div>
        )
      })
    }
  }
  getSubcategoriesForDisplay = (categories, currentCategoryPath) => {
    if (currentCategoryPath?.length < 3) return []

    const categoryIndex = parseInt(currentCategoryPath[2])

    const { categoryResponse, categories: propsCategories } = this.props

    let parentCategories = []
    if (enableNewFeature('enableRedesignMainMenu')) {
      if (propsCategories?.length > 0) {
        parentCategories = propsCategories
      } else {
        const response = get(categoryResponse, ['category'], {})
        parentCategories = response?.subCategories || []
      }
    } else {
      const response = get(categoryResponse, ['category'], {})
      parentCategories = response?.subCategories || []

      if (parentCategories?.length === 0 && propsCategories?.length > 0) {
        parentCategories = propsCategories
      }
    }

    const selectedCategory = parentCategories[categoryIndex]

    if (selectedCategory?.subCategories) {
      return selectedCategory.subCategories
    }

    return []
  }
  render() {
    const {
      categoryResponse,
      currentCategoryPath,
      categories: propsCategories,
      navigationData,
    } = this.props

    let categories = []

    if (enableNewFeature('enableRedesignMainMenu')) {
      if (propsCategories?.length > 0) {
        categories = propsCategories?.map((cat, index) => {
          const identifier =
            cat?.identifier ||
            cat?.label?.replace(/\s+/g, '_')?.toLowerCase() ||
            `category_${index}`
          return {
            identifier: identifier,
            properties: { name: cat?.label || '' },
            subCategories: cat?.subCategories || [],
            isDummyCategory: cat?.isDummyCategory || false,
            isLink: cat?.isLink || false,
            href: cat?.href || null,
          }
        })
      } else {
        const response = get(categoryResponse, currentCategoryPath, {})
        categories = response?.subCategories || []
      }
    } else {
      const response = get(categoryResponse, currentCategoryPath, {})
      categories = response?.subCategories || []
      if (categories?.length === 0 && propsCategories?.length > 0) {
        categories = propsCategories?.map((cat, index) => {
          const identifier =
            cat?.identifier ||
            cat?.label?.replace(/\s+/g, '_')?.toLowerCase() ||
            `category_${index}`
          return {
            identifier: identifier,
            properties: { name: cat?.label || cat?.name || '' },
            subCategories: cat?.subCategories || [],
            isDummyCategory: cat?.isDummyCategory || false,
            isLink: cat?.isLink || false,
            href: cat?.href || null,
          }
        })
      }
    }

    let filteredCategories = []

    if (enableNewFeature('enableRedesignMainMenu')) {
      filteredCategories = categories?.filter(
        category =>
          category &&
          Object?.keys(category)?.length > 0 &&
          category?.properties?.name &&
          category?.identifier
      )
    } else {
      filteredCategories = categories?.filter(
        category =>
          category &&
          Object?.keys(category)?.length > 0 &&
          (category?.properties?.name || category?.label)
      )
    }

    const response = get(categoryResponse, currentCategoryPath, {})
    const { name = '' } = response?.properties || {}
    return (
      <>
        {currentCategoryPath?.length > 1 && (
          <SubCategoryHeader
            category={
              response?.properties
                ? response
                : { properties: { name: 'Categories' } }
            }
            currentCategoryPath={currentCategoryPath}
            handleLinkClick={this.handleLinkClick}
            {...this.props}
          />
        )}
        <div className="submenu-accordians">
          {isArray(filteredCategories) && currentCategoryPath?.length === 1 && (
            <ListGroup>
              {filteredCategories?.map((category, index) => {
                if (category?.isLink && category?.href) {
                  const isExternalLink =
                    category?.href?.startsWith('http://') ||
                    category?.href?.startsWith('https://')
                  return (
                    <ListGroup.Item
                      key={`link-category-${index}`}
                      className="nu-menu-item mobile-link-category">
                      {isExternalLink ? (
                        <a
                          href={category?.href}
                          role="button"
                          onClick={this.handleLinkClick}>
                          {category?.properties?.name || category?.label || ''}
                        </a>
                      ) : (
                        <Link
                          to={category?.href}
                          role="button"
                          onClick={this.handleLinkClick}>
                          {category?.properties?.name || category?.label || ''}
                        </Link>
                      )}
                    </ListGroup.Item>
                  )
                } else if (
                  isArray(category?.subCategories) &&
                  category?.subCategories?.length > 0
                ) {
                  if (enableNewFeature('enableRedesignMainMenu')) {
                    return this.renderCategoryWithDropdown(category, index)
                  } else {
                    return (
                      <CategoryItem
                        key={`category-item-${index}`}
                        category={category}
                        index={index}
                        currentCategoryPath={currentCategoryPath}
                      />
                    )
                  }
                } else {
                  return (
                    <BrowseLink
                      key={`browse-link-${index}`}
                      category={category}
                      handleLinkClick={this.handleLinkClick}
                    />
                  )
                }
              })}
            </ListGroup>
          )}
          {currentCategoryPath?.length > 1 && (
            <SubMenuAccordian
              categories={this.getSubcategoriesForDisplay(
                categories,
                currentCategoryPath
              )}
              handleLinkClick={this.handleLinkClick}
            />
          )}
          <div className="d-flex flex-column">
            {this.renderStaticDropDownLinks(response)}
          </div>
        </div>
      </>
    )
  }
}

export { MobileMenuCategories, BrowseLink, CategoryItem }
